import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { postChannelBookmark } from '../../../api/channels';

import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { REQUEST } from '../../../constants/request';

export const addChannelBookmark = createAsyncThunk(
  'channels/addChannelBookmark',
  async ({ path, params = {} }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await postChannelBookmark(
        { path, params },
        {
          cancelToken: source.token,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const { channels } = getState();

      return !(
        channels.channels.bookmark.request[generateChannelCIDKey(path)]
          ?.loading === REQUEST.pending
      );
    },
  },
);

export const addChannelBookmarkExtraReducers = builder => {
  builder
    .addCase(addChannelBookmark.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.channels.bookmark.request,
        action,
        generateChannelCIDKey(action.meta.arg.path),
      );
    })
    .addCase(addChannelBookmark.fulfilled, (state, action) => {
      const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.channels.bookmark.request[channelCIDKey],
        action,
        () => {
          state.channels.bookmark.byId[channelCIDKey] = {
            ...state.channels.bookmark.byId[channelCIDKey],
            isBookmark: true,
          };

          if (!state.channels.bookmark.allIds.includes(channelCIDKey)) {
            state.channels.bookmark.allIds.push(channelCIDKey);
          }
        },
      );
    })
    .addCase(addChannelBookmark.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.bookmark.request[
          generateChannelCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
